
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Loading from '../loading/loading';
import styles from '../topbar/airports/airports.module.scss';
import { updateDefaultTenant } from '../topbar/airports/redux/actions';

class TenantSelection extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.state = {
      companyDropdown: false,
      loadingStatus: false
    };
  }

  componentDidMount() {
    if (performance.navigation.type === 1) {
      this.setState({ loadingStatus: false });
    }
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.apiStatusUser?.success === true) {
      this.setState({ loadingStatus: false }, () => {
        window.location.reload();
      });
    }
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    try {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClick(
      );
    } catch (ex) {
      // nothing
    }
  }

  handleClick() {
    const { companyDropdown } = this.state;
    if (!companyDropdown) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState(prevState => ({
      companyDropdown: !prevState.companyDropdown
    }));
  }

  async changeDefaultCompany(portal_tenant) {
    const { actionUpdateDefaultTenant } = this.props;
    localStorage.setItem('portal_tenantId', portal_tenant.id);
    actionUpdateDefaultTenant(portal_tenant);
    this.setState({ loadingStatus: true });
  }

  render() {
    const { companyDropdown, loadingStatus } = this.state;
    const { profile } = this.props;
    const { current_tenant, tenant } = profile;
    const airport_list = [];
    if (tenant) {
      const sortedTenant = [...tenant].sort((a, b) => a.name.localeCompare(b.name));
      sortedTenant.forEach((auth_company) => {
        airport_list.push(
          <li className={styles.item} key={auth_company.id}>
            <button type="button" onClick={() => this.changeDefaultCompany(auth_company)} style={{ color: 'black' }}>
              {auth_company.name}
            </button>
          </li>
        );
      });
    }
    return (
      <div className={styles.airports} ref={(node) => { this.node = node; }}>
        <button type="button" onClick={this.handleClick}>
          { current_tenant?.name }
        </button>
        {companyDropdown && airport_list.length > 1 && (
          <ul className={`${styles.dropdown} ${companyDropdown ? styles.open : ''}`}>
            {airport_list}
          </ul>
        )}
        <Loading loadingStatus={loadingStatus} />
      </div>
    );
  }
}

TenantSelection.propTypes = {
  profile: PropTypes.shape({
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    tenant: PropTypes.array
  }).isRequired
};
const mapStateToProps = state => ({
  action: state.updateairport?.action,
  apiStatusUser: state.updateairport?.apiStatusUser
});
const mapDispatchToProps = dispatch => ({
  actionUpdateDefaultTenant: (tenant) => {
    dispatch(updateDefaultTenant(tenant.id));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(TenantSelection));
